import { FETCH_SPECS_TREE_SUCCESS } from './types';

const INITIAL_STATE = {
  buildingAreas: [],
  buildingNumbers: [],
  categories: [],
  classifications: [],
  countries: [],
  currencies: [],
  geographicalAreas: [],
  languages: [],
  locationNames: [],
  materialCategories: [],
  subjects: [],
  surfaces: [],
  technologies: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SPECS_TREE_SUCCESS:
      return {
        ...state,
        buildingAreas: action.payload.buildingAreas,
        buildingNumbers: action.payload.buildingNumbers,
        categories: action.payload.categories,
        classifications: action.payload.classifications,
        countries: action.payload.countries,
        currencies: action.payload.currencies,
        geographicalAreas: action.payload.geographicalAreas,
        languages: action.payload.languages,
        locationNames: action.payload.locationNames,
        materialCategories: action.payload.materialCategories,
        subjects: action.payload.subjects,
        surfaces: action.payload.surfaces,
        technologies: action.payload.technologies,
      };

    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
